import imageCompression from 'browser-image-compression';

/**
 * Optimizes a course image for best performance:
 * - Resizes to max 1200px width
 * - Converts to WebP
 * - Applies balanced compression
 */
export async function optimizeCourseImage(file: File): Promise<File> {
  // If not an image, return as is
  if (!file.type.startsWith('image/')) {
    return file;
  }

  const options = {
    maxWidthOrHeight: 1200,
    useWebWorker: true,
    fileType: 'image/webp',
    initialQuality: 0.8,
  };

  try {
    const compressedBlob = await imageCompression(file, options);
    
    // Create a new File object from the compressed blob
    // Ensure the name ends with .webp
    const newFileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
    
    return new File([compressedBlob], newFileName, {
      type: 'image/webp',
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error('Image optimization failed:', error);
    // Fallback to original file
    return file;
  }
}
